var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"player-main",style:(_vm.contStyles)},[(_vm.item.fileType == 'image')?_c('img',{style:(_vm.styles),attrs:{"src":_vm.item.url}}):_c('video',{ref:"videoPlayer",style:(_vm.styles),attrs:{"loop":"","autoplay":"","muted":"","src":_vm.item.url},domProps:{"muted":true}})])
}
var staticRenderFns = []

export { render, staticRenderFns }